import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';
import frCATranslation from './locales/fr-CA/translation.json';
import esTranslation from './locales/es-419/translation.json';

const resources = {
  en: {
    translation: enTranslation,
  },
  'fr-CA': {
    translation: frCATranslation,
  },
  'es-419': {
    translation: esTranslation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Route any Spanish region variant (es, es-MX, es-AR, es-ES, ...) to es-419.
    fallbackLng: {
      es: ['es-419', 'en'],
      default: ['en'],
    },
    supportedLngs: ['en', 'fr-CA', 'es-419'],
    detection: {
      // Order of language detection - URL param first, then browser
      order: ['querystring', 'navigator'],
      // URL param name
      lookupQuerystring: 'lang',
      // Cache user language preference
      caches: [],
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

// Update document lang attribute when language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

// Set initial lang attribute
document.documentElement.lang = i18n.language;

export default i18n;
